<app-header></app-header>
<app-sidebar
  ativo="Contatos"
></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-detalhes-clientes
      [id]="id ? Number(id) : 0"
    ></app-detalhes-clientes>
  </section>
</div>
